<template>
  <ViewContainer :title="$t('menu.user.my_activity')">
    <LogsTable
      :columnsEnabled="columnsEnabled"
      :filtersEnabled="filtersEnabled"
      @updateTable="getLogs"
    />
  </ViewContainer>
</template>

<script>
import ViewContainer from '@/components/Core/Layout/ViewContainer.vue'
import LogsTable from './LogsTable.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AccountAuditLogs',

  components: {
    LogsTable,
    ViewContainer,
  },

  data() {
    return {
      modalStatus: false,
      columnsEnabled: [
        'eventName',
        'eventTime',
        'sourceAccountName',
        'sourceOrganizationId',
        'sourceAccountIP',
        'eventDescription',
        'userAgent',
        'userAgentVersion',
        'responseType',
        'targetAccountId',
        'targetType',
        'targetId',
        'targetOrganizationId',
      ],
      filtersEnabled: ['eventName', 'targetType', 'targetId'],
    }
  },

  created() {
    this.getLogs()
  },
  computed: {
    ...mapGetters(['organizationId', 'accountId']),
  },
  methods: {
    ...mapActions(['getAccountAuditLogs']),
    getLogs() {
      return this.getAccountAuditLogs({
        organizationId: this.organizationId,
        accountId: this.accountId,
      })
    },
  },
}
</script>
